import React from "react";
import {
  Box,
  TextField,
  MenuItem,
  Typography,
  Grid,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";

const RegistroCeldasModal = ({ isOpen, onClose }) => {
  return (
    <Dialog open={isOpen} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Registro de Celdas</DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} sm={4}>
            <Typography variant="subtitle1">Nombre de la celda</Typography>
          </Grid>
          <Grid item xs={12} sm={8}>
            <TextField fullWidth placeholder="Escriba aquí......" />
          </Grid>

          <Grid item xs={12} sm={4}>
            <Typography variant="subtitle1">Tipo de cargador</Typography>
          </Grid>
          <Grid item xs={12} sm={8}>
            <TextField select fullWidth defaultValue="">
              <MenuItem value="Tipo 1">Tipo 1</MenuItem>
              <MenuItem value="Tipo 2">Tipo 2</MenuItem>
            </TextField>
          </Grid>

          <Grid item xs={12} sm={4}>
            <Typography variant="subtitle1">Es un cargador o un suich</Typography>
          </Grid>
          <Grid item xs={12} sm={8}>
            <TextField select fullWidth defaultValue="">
              <MenuItem value="Cargador">Cargador</MenuItem>
              <MenuItem value="Suich">Suich</MenuItem>
            </TextField>
          </Grid>

          <Grid item xs={12} sm={4}>
            <Typography variant="subtitle1">Hora de inicio de los bloques</Typography>
          </Grid>
          <Grid item xs={12} sm={8}>
            <TextField select fullWidth defaultValue="">
              <MenuItem value="08:00">08:00 AM</MenuItem>
              <MenuItem value="09:00">09:00 AM</MenuItem>
            </TextField>
          </Grid>

          <Grid item xs={12} sm={4}>
            <Typography variant="subtitle1">Minutos de notificación al usuario antes de la reserva</Typography>
          </Grid>
          <Grid item xs={12} sm={8}>
            <TextField select fullWidth defaultValue="">
              <MenuItem value="5">5 minutos</MenuItem>
              <MenuItem value="10">10 minutos</MenuItem>
            </TextField>
          </Grid>

          <Grid item xs={12} sm={4}>
            <Typography variant="subtitle1">Minutos de notificación al usuario antes finalizar la reserva</Typography>
          </Grid>
          <Grid item xs={12} sm={8}>
            <TextField select fullWidth defaultValue="">
              <MenuItem value="5">5 minutos</MenuItem>
              <MenuItem value="10">10 minutos</MenuItem>
            </TextField>
          </Grid>

          <Grid item xs={12} sm={4}>
            <Typography variant="subtitle1">Agendar con Google calendario</Typography>
          </Grid>
          <Grid item xs={12} sm={8}>
            <TextField select fullWidth defaultValue="No">
              <MenuItem value="Si">Sí</MenuItem>
              <MenuItem value="No">No</MenuItem>
            </TextField>
          </Grid>

          <Grid item xs={12} sm={4}>
            <Typography variant="subtitle1">Valor de la reserva por bloque (Opcional)</Typography>
          </Grid>
          <Grid item xs={12} sm={8}>
            <TextField fullWidth placeholder="Escriba aquí......" />
          </Grid>

          <Grid item xs={12} sm={4}>
            <Typography variant="subtitle1">Valor del kilovatio</Typography>
          </Grid>
          <Grid item xs={12} sm={8}>
            <TextField fullWidth placeholder="Escriba aquí......" />
          </Grid>

          <Grid item xs={12} sm={4}>
            <Typography variant="subtitle1">Valor de deposito por uso (Opcional)</Typography>
          </Grid>
          <Grid item xs={12} sm={8}>
            <TextField fullWidth placeholder="Escriba aquí......" />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} style={{ color: "#1d1d1b" }}>
          Cancelar
        </Button>
        <Button
          onClick={onClose} // Debería ser handleSave en un futuro
          style={{ backgroundColor: "#0A2139", color: "#f1f1f1" }}
          variant="contained"
        >
          Guardar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RegistroCeldasModal;
